export default __webpack_public_path__ + "static/media/grapes.97ea8023.webp";